export default "__VITE_PUBLIC_ASSET__95bcee74__"